var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.36255H5.25",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.3625V4.89751C1.5 3.36751 2.7375 2.13 4.2675 2.13H8.4825C10.0125 2.13 11.25 3.0825 11.25 4.6125",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.11 9.15004C12.735 9.51004 12.555 10.065 12.705 10.635C12.8925 11.3325 13.5825 11.775 14.3025 11.775H15V12.8625C15 14.52 13.6575 15.8625 12 15.8625H4.5C2.8425 15.8625 1.5 14.52 1.5 12.8625V7.61255C1.5 5.95505 2.8425 4.61255 4.5 4.61255H12C13.65 4.61255 15 5.96255 15 7.61255V8.70001H14.19C13.77 8.70001 13.3875 8.86504 13.11 9.15004Z",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 9.46497V11.01C16.4999 11.43 16.1549 11.775 15.7274 11.775H14.2799C13.4699 11.775 12.7274 11.1825 12.6599 10.3725C12.6149 9.89998 12.7949 9.45748 13.1099 9.14998C13.3874 8.86498 13.7699 8.69995 14.1899 8.69995H15.7274C16.1549 8.69995 16.4999 9.04497 16.4999 9.46497Z",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.eee1ce7dd65dd37ac3982d8dc1a12a9d.svg";
export { ForwardRef as ReactComponent };